import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IRoleModel } from 'src/app/models/interfaces/IRoleModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RolService {
  // private configUrl = 'api/roles';
  private configUrl = [environment.apiGatewayUrl, 'roles'].join('/');

  constructor(private http: HttpClient) { }

  getList() : Observable<SearchResultModel<IRoleModel[]>> {
    return this.http.get<SearchResultModel<IRoleModel[]>>(this.configUrl);
  }

  getById(id: number) : Observable<IRoleModel> {
    return this.http.get<IRoleModel>(`${this.configUrl}/${id}`);
  }
}
